
const colours = {
    contrast: '#f7f7f7',
    white: '#ffffff',
    black: '#000000',
    grey: '#4A4A4A',
    greylight: '#f7f7f7',
    bordergrey: '#CECFD0',
    red: '#eb4034',
    green: '#96CB13',
    border: '#CECFD0',
    dark: '#1B1A33',
    muted: '#AAAAAA',
    gold: '#B1956A',
}

export default colours;
